import { createAction, props } from '@ngrx/store';
import { ContractError } from 'src/app/core/models/models';
import {
  SpecialRequestQuoteRequest,
  SpecialRequestCategoryQuote,
  SpecialRequestConfirmation,
  SpecialRequestItem,
  SpecialRequestCategory,
} from 'src/app/core/models/special-requests.model';
import { QuoteRequest } from 'src/app/core/models/itinerary.model';

export const getSpecialRequestQuote = createAction(
  '[Special Request Page] get special request quote fail',
  props<{ quoteRequest: QuoteRequest }>()
);

export const searchSpecialRequest = createAction(
  '[Special Request Page] Search Special Request',
  props<{ searchValue: string }>()
);

export const filteredSearch = createAction(
  '[Special Request Page] Filtered search',
  props<{ filtered: SpecialRequestCategory[] }>()
);

export const goToStep2 = createAction(
  '[Special Request Page] go to step 2',
  props<{ specialRequestItem: SpecialRequestItem }>()

);

export const goToStep1 = createAction(
  '[Special Request Page] back to step 1',
);

export const getSpecialRequestQuoteSuccess = createAction(
  '[Special Request Page] get special request quote success',
  props<{ specialRequestCategoryQuote: SpecialRequestCategoryQuote }>()
);

export const postSpecialRequest = createAction(
  '[Special Request/Special Requests Page] special request',
  props<{ specialRequestQuoteRequest: SpecialRequestQuoteRequest }>()
);

export const postSpecialRequestSuccess = createAction(
  '[Special Request Page] special request success',
  props<{ specialRequestConfirmation: SpecialRequestConfirmation[], isSuccessful: boolean }>()
);

export const postSpecialRequestFail = createAction(
  '[Special Request Page] special request fail',
  props<{ error: ContractError }>()
);
